<template>
  <div class="supportingDocuments px-2 lg:px-0">
    <div class="supportingDocuments-1 relative">
      <img class=" absolute -right-2 top-9 w-40" src="@/assets/images/home/round.svg" alt="">
      <img class=" absolute right-40 top-9 w-20" src="@/assets/images/home/round.svg" alt="">
      <img class=" absolute left-9 bottom-9 w-20" src="@/assets/images/home/round.svg" alt="">
      <div class="container mx-auto py-28 items-center">
        <div class="flex flex-col lg:px-80">
          <div class="text-main text-4xl text-center font-semibold">{{ overview.title }}</div>
          <div class="text-sub-title text-base text-center pt-8" v-html="overview.description"></div>
          <div class="text-center pt-10">
            <a :href="options.openTradingAccountLink">
              <el-button class="px-2 py-3 rounded-lg lg:px-4" type="danger" style="margin-bottom: 10px;">{{
                options.openTradingAccountText
                }}</el-button>
            </a>
            <a :href="options.openDemoAccountLink" class="ml-2">
              <el-button class="px-2 py-3 rounded-lg lg:px-4" style="margin-bottom: 10px;">{{
                options.openDemoAccountText }}</el-button>
            </a>
          </div>
        </div>
        <img class="m-auto mt-16" :src="$path + overview.image?.data?.attributes?.url" />
        <!-- <img class="m-auto mt-16" src="../../assets/images/account/support-top2.svg" /> -->
      </div>
    </div>
    <div class="supportingDocuments-2">
      <div class="pt-10 container mx-auto flex flex-col h-full lg:pt-16 text-base">
        <div class="text-main font-semibold text-2xl">{{ overview.titleSecond }}</div>
        <div v-html="overview.descriptionSecond"></div>
        <div class="grid grid-cols-2 gap-4 lg:inline-flex img-content mt-10 pl-8 lg:pl-0">
          <img class="h-24" src="../../assets/images/account/nigeria.png" />
          <img class="h-24" src="../../assets/images/account/philippines.png" />
          <img class="h-24" src="../../assets/images/account/korea.png" />
          <img class="h-24" src="../../assets/images/account/thailand.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import $ from 'jquery'
import { mapGetters } from 'vuex'
import { getSupportDocument } from '@/api/account'

export default {
  name: 'Home',
  data() {
    return {
      xsShow: false, // 手机显示
      activeWidth: window.innerWidth,
      overview: {}
    }
  },
  watch: {
    activeWidth: {
      handler(val, oldVal) {
        if (val <= 416) {
          this.xsShow = true
        } else {
          this.xsShow = false
        }
      },
      deep: true, // true 深度监听
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      lang: 'getLang'
    }),
    lang() {
      return this.$store.state.lang
    },
    options() {
      return this.$store.getters.options
    }
  },
  components: {},
  created() {
    this.getSupportDocument()
  },
  mounted() {
  },
  methods: {
    async getSupportDocument() {
      const params = {
        'populate[country][fields]': '*',
        'populate[image][fields]': 'url'
      }
      const result = await getSupportDocument(params)
      this.overview = result.data.attributes
    }
  }
}
</script>

<style lang="less" scoped>
.supportingDocuments {
  background: #F9FAFB;

  .supportingDocuments-1 {
    background-color: #fff;
    background-image: url("../../assets/images/home/advantage.svg");
    margin-bottom: 30px;
  }

  .supportingDocuments-2 {
    margin-bottom: 50px;

    ul {
      li {
        list-style-type: disc;
      }
    }

    .img-content {
      position: relative;
      left: -15px;
    }
  }
}

@media screen and (max-width: 768px) {
  .supportingDocuments {}
}
</style>
